"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var common_1 = require("../../common");
var Table = /** @class */ (function (_super) {
    tslib_1.__extends(Table, _super);
    function Table(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setRef = function (el) {
            _this.$table = el;
        };
        _this.onWindowScroll = function (e) {
            _this.setStickyHeader();
            _this.loadMoreItems();
        };
        _this.onWindowResize = function (e) {
            _this.setStickyHeader();
        };
        _this.$table = null;
        _this.stickyHeader = false;
        return _this;
    }
    Table.prototype.componentDidMount = function () {
        this.setStickyHeader();
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
        window.addEventListener("resize", this.onWindowResize);
    };
    Table.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
        window.removeEventListener("resize", this.onWindowResize);
    };
    Table.prototype.componentDidUpdate = function () {
        if (this.stickyHeader) {
            this.setStickyHeader();
        }
    };
    Table.prototype.setStickyHeader = function () {
        var _this = this;
        var _a = this.props, enableStickyHeader = _a.enableStickyHeader, stickyHeaderOffsetTop = _a.stickyHeaderOffsetTop;
        if (!enableStickyHeader || !this.$table) {
            return;
        }
        utils_1.raf(function () {
            if (!_this.$table) {
                return;
            }
            var thead = _this.$table.querySelector("thead");
            if (!thead) {
                return;
            }
            var tableRect = _this.$table.getBoundingClientRect();
            var theadRect = thead.getBoundingClientRect();
            if (tableRect.top < stickyHeaderOffsetTop) {
                var absTop = Math.abs(tableRect.top);
                var translateY = void 0;
                if (tableRect.top + tableRect.height - stickyHeaderOffsetTop <= theadRect.height) {
                    translateY = tableRect.height - theadRect.height;
                }
                else {
                    translateY = tableRect.top > 0
                        ? stickyHeaderOffsetTop - tableRect.top
                        : stickyHeaderOffsetTop + absTop;
                }
                _this.stickyHeader = true;
                thead.style.transform = "translateY(" + translateY + "px)";
            }
            else {
                _this.stickyHeader = false;
                thead.style.transform = "";
            }
        });
    };
    Table.prototype.loadMoreItems = function () {
        var _this = this;
        var _a = this.props, loadMoreItems = _a.loadMoreItems, loadMoreItemsGap = _a.loadMoreItemsGap;
        utils_1.raf(function () {
            if (!loadMoreItems || !_this.$table) {
                return;
            }
            var winScrollY = window.scrollY;
            var winInnerHeight = window.innerHeight;
            var tableOffsetHeight = _this.$table.offsetHeight;
            var tableOffsetTop = _this.$table.offsetTop;
            if (winScrollY + winInnerHeight + _this.props.loadMoreItemsGap >= (tableOffsetHeight + tableOffsetTop)) {
                loadMoreItems();
            }
        });
    };
    Table.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, theme = _b.theme, className = _b.className, density = _b.density, fill = _b.fill, stickyHeaderOffsetTop = _b.stickyHeaderOffsetTop, enableStickyHeader = _b.enableStickyHeader, loadMoreItems = _b.loadMoreItems, loadMoreItemsGap = _b.loadMoreItemsGap, others = tslib_1.__rest(_b, ["children", "theme", "className", "density", "fill", "stickyHeaderOffsetTop", "enableStickyHeader", "loadMoreItems", "loadMoreItemsGap"]);
        var classes = classnames_1.default(theme.table, className, (_a = {},
            _a[theme.fill] = fill,
            _a[theme.small] = density === common_1.Density.Small,
            _a[theme.medium] = density === common_1.Density.Medium,
            _a[theme.large] = density === common_1.Density.Large,
            _a));
        return (React.createElement("table", tslib_1.__assign({}, others, { ref: this.setRef, className: classes }), children));
    };
    Table.defaultProps = {
        density: common_1.Density.Medium,
        stickyHeaderOffsetTop: 0,
        loadMoreItemsGap: 100
    };
    return Table;
}(React.Component));
exports.default = Table;
